import React, { useEffect, useState } from "react";
import {
  getAllLiabilityType,
  getBeneficiaryDetails,
  toEditLiabilities,
} from "../../../apis/actions/recipient.actions";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import PrimaryButton from "../../../biblio/Buttons/PrimaryButton";
import { PlusCircleOutlined } from "@ant-design/icons";
import Inputs from "../../../biblio/Inputs/Inputs";
import Selects from "../../../biblio/Selects/Selects";
import { Col, Row, Table } from "antd";
import SecondaryButton from "../../../biblio/Buttons/SecondaryButton";
import ModalComponent from "../../../biblio/Modal/ModalComponent";
import { showNotitfication } from "../../../components/utils/utils";
import { setEditMode } from "../../../apis/slices/recipientSlice";

interface EditProps {
  liabilities: any[];
}

const EditLiablityTable = ({ liabilities }: EditProps) => {
  const newRowTemplateLiability = {
    key: liabilities.length,
    id: null,
    number: 1,
  };
  const [liabilityData, setLiabilityData] = useState<any[]>([]);
  const [updatedliabilityData, setUpdateliabilityData] = useState<any[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const { liabilityTypes, editMode } = useSelector(
    (state: RootState) => state.recipient
  );
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (Array.isArray(liabilities)) {
      setLiabilityData([...liabilities]);
    }
  }, [liabilities]);
  useEffect(() => {
    dispatch(getAllLiabilityType());
  }, [dispatch]);
  const addNewLiability = () => {
    const uniqueKey = Date.now();
    setLiabilityData((prev) => [
      ...prev,
      { ...newRowTemplateLiability, key: uniqueKey },
    ]);
  };

  const handleLiabilityChange = (index: number, field: string, value: any) => {
    setLiabilityData((prev) => {
      const updatedData = [...prev];
      if (!updatedData[index]) return prev;

      updatedData[index] = {
        ...updatedData[index],
        [field]: value,
      };
      setUpdateliabilityData((prevChanges) => {
        const changes = [...prevChanges];
        const existingChangeIndex = changes.findIndex((item) =>
          item.key
            ? item.key === updatedData[index].key
            : item.id === updatedData[index].id
        );

        if (existingChangeIndex !== -1) {
          changes[existingChangeIndex] = {
            ...changes[existingChangeIndex],
            [field]: value,
          };
        } else {
          const { amount, total, ...sanitizedData } = updatedData[index];

          const matchedType = liabilityTypes.find(
            (type : any) =>
              type.name === sanitizedData.liability_type_id ||
              type.id === sanitizedData.liability_type_id
          );

          changes.push({
            ...sanitizedData,
            liability_type_id:
              matchedType?.id ?? sanitizedData.liability_type_id,
          });
        }

        return changes;
      });

      return updatedData;
    });
  };
  const columnsLiability = [
    {
      title: "الإلتزام",
      dataIndex: "liability_type_id",
      key: "liability_type_id",
      width: "25%",
      render: (text: string, record: any, index: number) =>
        editMode ? (
          <Selects
            allowClear={false}
            value={record.liability_type_id}
            onChange={(SelectedValue: any) =>
              handleLiabilityChange(
                index,
                "liability_type_id",
                SelectedValue.key
              )
            }
            options={liabilityTypes}
          />
        ) : (
          <span>{text}</span>
        ),
    },

    {
      title: "العدد",
      dataIndex: "number",
      key: "number",
      width: "25%",
      render: (text: string, record: any, index: number) =>
        editMode ? (
          <Inputs
            type="tel"
            defaultValue={1}
            value={record.number || 1}
            onChange={(e) =>
              handleLiabilityChange(index, "number", parseInt(e.target.value))
            }
          />
        ) : (
          <span className="takaful--service-request-span">{text}</span>
        ),
    },
    {
      title: "المبلغ",
      key: "amount",
      width: "25%",
      render: (_: any, record: any) => {
        const typeObj = liabilityTypes.find(
          (t: any) =>
            t.id === record.liability_type_id ||
            t.name === record.liability_type_id
        );
        const amount = typeObj ? typeObj.amount : 0;
        return (
          <span className="takaful--service-request-span">
            {Number.isInteger(amount) ? amount : amount.toFixed(2)}
          </span>
        );
      },
    },
    {
      title: "المبلغ الجملي",
      key: "total",
      width: "25%",
      render: (_: any, record: any) => {
        const typeObj = liabilityTypes.find(
          (t: any) =>
            t.id === record.liability_type_id ||
            t.name === record.liability_type_id
        );
        const amount = typeObj ? typeObj.amount : 0;

        const number = record.number;

        // eslint-disable-next-line eqeqeq
        const total = amount * (number != 0 ? number : 1);

        return (
          <span className="takaful--service-request-span">
            {Number.isInteger(total) ? total : total.toFixed(2)}
          </span>
        );
      },
    },

    {
      // eslint-disable-next-line eqeqeq
      title: editMode == true && (
        <PrimaryButton
          icon={<PlusCircleOutlined />}
          title=""
          onClick={addNewLiability}
        />
      ),
    },
  ];
  const cancelModification = () => {
    setIsModalVisible(false);
  };
  const confirmModification = () => {
    try {
      const filteredLiabilityData = updatedliabilityData.map((item) => {
        if (item.id == null) {
          const { id, key, ...rest } = item;
          return rest;
        }
        return item;
      });

      const apiPayload = {
        liability_ids: [...filteredLiabilityData],
      };

      dispatch(toEditLiabilities(apiPayload)).then((result: any) => {
        const response = result?.payload?.data?.result;
        if (response?.code === 200) {
          showNotitfication(response?.message, "success");
          setIsModalVisible(false);
          dispatch(getBeneficiaryDetails());
          dispatch(setEditMode(false));
          setUpdateliabilityData([]);
        } else {
          showNotitfication(response?.message, "error");
          setIsModalVisible(false);
        }
      });
    } catch (error) {
      console.error("error:", error);
    }
  };
  return (
    <div className="takaful--table-service-container">
      <Table
        className="takaful--table"
        style={{ direction: "rtl", textWrap: "nowrap" }}
        columns={columnsLiability}
        scroll={{ x: "max-content" }}
        dataSource={liabilityData}
        pagination={false}
        locale={{
          emptyText: (
            <span className="takaful--empty-text-table">لا توجد بيانات</span>
          ),
        }}
      />
      {/* eslint-disable-next-line eqeqeq */}
      {editMode == true && (
        <Row
          justify={"space-between"}
          className="takaful--content-profile-box1"
        >
          <Col
            xxl={5}
            xl={5}
            lg={5}
            md={5}
            sm={12}
            xs={10}
            className="takaful--content-profile-col"
          ></Col>
          <div className="takaful--sponsor-secondary-button">
            <SecondaryButton
              title="تعديل"
              onClick={() => {
                setIsModalVisible(true);
              }}
              disabled={
                // eslint-disable-next-line eqeqeq
                updatedliabilityData.length == 0
              }
            />
          </div>
        </Row>
      )}
      <ModalComponent
        title=""
        open={isModalVisible}
        onClose={cancelModification}
        closeOnOutsideClick={true}
        centered={true}
      >
        <Row justify={"center"}>
          <p className="takaful--confirm-logout">
            هل أنت متأكد أنك تريد إعتماد التعديل؟
          </p>
        </Row>
        <Row gutter={16} justify={"center"} style={{ paddingTop: "2rem" }}>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--cancel-btn-logout"
              onClick={cancelModification}
              title="لا"
            />
          </Col>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--confirm-btn-logout"
              title="نعم"
              onClick={confirmModification}
            />
          </Col>
        </Row>
      </ModalComponent>
    </div>
  );
};
export default EditLiablityTable;
